module.exports = __webpack_public_path__ + "media/חוט.66568f68.mp3";